export const category = [
    {
        key: "বাংলা ভাষা ও সাহিত্য",
        text: "বাংলা ভাষা ও সাহিত্য",
        value: "বাংলা ভাষা ও সাহিত্য"
    },
    {
        key: "English Language and Literature",
        text: "English Language and Literature",
        value: "English Language and Literature"
    },
    {
        key: "বাংলাদেশ বিষয়াবলি",
        text: "বাংলাদেশ বিষয়াবলি",
        value: "বাংলাদেশ বিষয়াবলি"
    },

    {
        key: "আন্তর্জাতিক বিষয়াবলি",
        text: "আন্তর্জাতিক বিষয়াবলি",
        value: "আন্তর্জাতিক বিষয়াবলি"
    },
    {
        key: "ভূগোল (বাংলাদেশ ও বিশ্ব), পরিবেশ ও দুর্যোগ ব্যবস্থাপনা",
        text: "ভূগোল (বাংলাদেশ ও বিশ্ব), পরিবেশ ও দুর্যোগ ব্যবস্থাপনা",
        value: "ভূগোল (বাংলাদেশ ও বিশ্ব), পরিবেশ ও দুর্যোগ ব্যবস্থাপনা"
    },
    { key: "সাধারণ বিজ্ঞান", text: "সাধারণ বিজ্ঞান", value: "সাধারণ বিজ্ঞান" },

    {
        key: "কম্পিউটার ও তথ্য প্রযুক্তি",
        text: "কম্পিউটার ও তথ্য প্রযুক্তি",
        value: "কম্পিউটার ও তথ্য প্রযুক্তি"
    },
    { key: "গাণিতিক যুক্তি", text: "গাণিতিক যুক্তি", value: "গাণিতিক যুক্তি" },
    { key: "মানসিক দক্ষতা", text: "মানসিক দক্ষতা", value: "মানসিক দক্ষতা" },
    {
        key: "নৈতিকতা, মূল্যবোধ ও সু-শাসন",
        text: "নৈতিকতা, মূল্যবোধ ও সু-শাসন",
        value: "নৈতিকতা, মূল্যবোধ ও সু-শাসন"
    }
];

export const categoryDivision = {
    "বাংলা ভাষা ও সাহিত্য": [
        {
            key: "ভাষা",
            text: "ভাষা",
            value: "ভাষা"
        },
        {
            key: "সাহিত্য",
            text: "সাহিত্য",
            value: "সাহিত্য"
        }
    ],
    "English Language and Literature": [
        {
            key: "Language",
            text: "Language",
            value: "Language"
        },
        {
            key: "Literature",
            text: "Literature",
            value: "Literature"
        }
    ],
    "সাধারণ বিজ্ঞান": [
        {
            key: "ভৌত বিজ্ঞান",
            text: "ভৌত বিজ্ঞান",
            value: "ভৌত বিজ্ঞান"
        },
        {
            key: "জীব বিজ্ঞান",
            text: "জীব বিজ্ঞান",
            value: "জীব বিজ্ঞান"
        },
        {
            key: "আধুনিক বিজ্ঞান",
            text: "আধুনিক বিজ্ঞান",
            value: "আধুনিক বিজ্ঞান"
        }
    ],
    "কম্পিউটার ও তথ্য প্রযুক্তি": [
        {
            key: "কম্পিউটার",
            text: "কম্পিউটার",
            value: "কম্পিউটার"
        },
        {
            key: "তথ্যপ্রযুক্তি",
            text: "তথ্যপ্রযুক্তি",
            value: "তথ্যপ্রযুক্তি"
        }
    ],
    "গাণিতিক যুক্তি": [
        {
            key: "বাস্তব সংখ্যা",
            text: "বাস্তব সংখ্যা",
            value: "বাস্তব সংখ্যা"
        },
        {
            key: "বীজগাণিতিক সূত্রাবলি",
            text: "বীজগাণিতিক সূত্রাবলি",
            value: "বীজগাণিতিক সূত্রাবলি"
        },
        {
            key: "সূচক ও লগারিদম",
            text: "সূচক ও লগারিদম",
            value: "সূচক ও লগারিদম"
        },
        {
            key: "জ্যামিতি",
            text: "জ্যামিতি",
            value: "জ্যামিতি"
        },
        {
            key: "সেট",
            text: "সেট",
            value: "সেট"
        }
    ]
};

export const subDivision = {
    ভাষা: [
        {
            key: "প্রয়োগ-অপপ্রয়োগ",
            text: "প্রয়োগ-অপপ্রয়োগ",
            value: "প্রয়োগ-অপপ্রয়োগ"
        },
        {
            key: "বানান ও বাক্য শুদ্ধি",
            text: "বানান ও বাক্য শুদ্ধি",
            value: "বানান ও বাক্য শুদ্ধি"
        },
        {
            key: "পরিভাষা",
            text: "পরিভাষা",
            value: "পরিভাষা"
        },
        {
            key: "ধ্বনি",
            text: "ধ্বনি",
            value: "ধ্বনি"
        },
        {
            key: "বর্ণ",
            text: "বর্ণ",
            value: "বর্ণ"
        },
        {
            key: "শব্দ",
            text: "শব্দ",
            value: "শব্দ"
        },
        {
            key: "পদ",
            text: "পদ",
            value: "পদ"
        },
        {
            key: "বাক্য",
            text: "বাক্য",
            value: "বাক্য"
        },
        {
            key: "প্রত্যয়",
            text: "প্রত্যয়",
            value: "প্রত্যয়"
        },
        {
            key: "সন্ধি",
            text: "সন্ধি",
            value: "সন্ধি"
        },
        {
            key: "সমাস",
            text: "সমাস",
            value: "সমাস"
        }
    ],
    সাহিত্য: [
        {
            key: "প্রাচীন ও মধ্যযুগ",
            text: "প্রাচীন ও মধ্যযুগ",
            value: "প্রাচীন ও মধ্যযুগ"
        },
        {
            key: "আধুনিক যুগ (১৮০০-বর্তমান পর্যন্ত)",
            text: "আধুনিক যুগ (১৮০০-বর্তমান পর্যন্ত)",
            value: "আধুনিক যুগ (১৮০০-বর্তমান পর্যন্ত)"
        }
    ],
    Language: [
        {
            key: "Parts of Speech",
            text: "Parts of Speech",
            value: "Parts of Speech"
        },
        {
            key: "Idioms & Phrases",
            text: "Idioms & Phrases",
            value: "Idioms & Phrases"
        },
        {
            key: "Clauses",
            text: "Clausess",
            value: "Clauses"
        },
        {
            key: "Corrections",
            text: "Corrections",
            value: "Corrections"
        },
        {
            key: "Sentences & Transformations",
            text: "Sentences & Transformations",
            value: "Sentences & Transformations"
        },
        {
            key: "Words",
            text: "Words",
            value: "Words"
        },
        {
            key: "Composition",
            text: "Composition",
            value: "Composition"
        }
    ],
    Literature: [
        {
            key: "Literary pieces",
            text: "Literary pieces",
            value: "Literary pieces"
        },
        {
            key: "Drama/poetry",
            text: "Drama/poetry",
            value: "Drama/poetry"
        }
    ]
};
